import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../constants';
import { useAppSelector, useFeatureFlag } from '../../hooks';
import { LD_FeatureFlags, Permissions, ScoringAndCoachingTabs } from '../../types';
import { Icon, Icons } from '../shared';
import SidebarButtonGroup from './SidebarButtonGroup';

const ScoringAndCoachingSidebarContent = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { user } = useAppSelector((state) => state.auth);
  const coachingRubricsFF = useFeatureFlag(LD_FeatureFlags.RELEASE_COACHING_RUBRICS);

  const permissions = user?.permissions || [];
  const canModifyScorecardTemplates = permissions.includes(Permissions.MODIFY_SCORECARD_TEMPLATE);
  const canModifyCoachingTemplates = permissions.includes(Permissions.MODIFY_COACHING_TEMPLATE);

  const items = useMemo(
    () => [
      {
        id: ScoringAndCoachingTabs.SCORECARDS,
        disabled: !canModifyScorecardTemplates,
        endElement: <Icons icon={Icon.SCORECARD} />,
      },
      {
        id: ScoringAndCoachingTabs.COACHING_RUBRICS,
        disabled: !canModifyCoachingTemplates || !coachingRubricsFF,
        endElement: <Icons icon={coachingRubricsFF ? Icon.COACHING : Icon.LOCK} />,
      },
    ],
    [canModifyCoachingTemplates, canModifyScorecardTemplates, coachingRubricsFF]
  );

  return (
    <SidebarButtonGroup
      items={items.map((item) => ({
        ...item,
        active: pathname.includes(item.id),
        onClick: () => navigate(AppRoutes.SCORING_AND_COACHING + '/' + item.id, { replace: true }),
      }))}
    />
  );
};

export default ScoringAndCoachingSidebarContent;
